export const Province = {
  "آذربایجان شرقی": 28,
  "آذربایجان غربی": 16,
  "اردبیل": 19,
  "اصفهان": 13,
  "البرز": 27,
  "ایلام": 3,
  "بوشهر": 18,
  "تهران": 25,
  "چهارمحال و بختیاری": 6,
  "خراسان جنوبی": 23,
  "خراسان رضوی": 22,
  "خراسان شمالی": 1,
  "خوزستان": 31,
  "زنجان": 11,
  "سمنان": 12,
  "سیستان و بلوچستان": 24,
  "فارس": 17,
  "قزوین": 9,
  "قم": 26,
  "کردستان": 15,
  "کرمان": 2,
  "کرمانشاه": 7,
  "کهگیلویه و بویراحمد": 14,
  "گلستان": 21,
  "گیلان": 10,
  "لرستان": 4,
  "مازندران": 20,
  "مرکزی": 5,
  "هرمزگان": 30,
  "همدان": 8,
  "یزد": 29,
}

export const Province_Center = [
  [37.47220147534966, 57.32919216156006], // northkhorasan
  [30.291163169636707, 57.06770896911621], // kerman
  [33.63491667679363, 46.40719413757324], // ilam
  [33.48657861929678, 48.35606575012207], // lorestan
  [34.09595600596673, 49.701805114746094], // markazi
  [32.33225353369601, 50.856571197509766], // chaharmahalandbakhtiari
  [34.329473930636794, 47.08070755004883], // kermanshah
  [34.798298899001196, 48.51489543914795], // hamadan
  [36.29015440311434, 50.0083065032959], // qazvin
  [37.28060928450999, 49.592199325561516], // gilan
  [36.67544081082709, 48.5115909576416], // zanjan
  [35.58351321440279, 53.38879108428955], // semnan
  [32.6791180993732, 51.672134399414055], // isfahan
  [30.667299525791496, 51.58003807067871], // kohgiluyehandboyerahmad
  [35.311553247291386, 46.99625015258789], // kurdistan
  [37.55308350936187, 45.07596015930176], // westazerbaijan
  [29.614356425026187, 52.524261474609375], // fars
  [28.968536888453823, 50.83687305450439], // bushehr
  [38.25162821893197, 48.29765796661377], // ardabil
  [36.563909881837766, 53.06319236755371], // mazandaran
  [36.8416445052441, 54.43305015563965], // golestan
  [36.297833239417564, 59.607009887695305], // razavikhorasan
  [32.87317166460953, 59.21630859374999], // southkhorasan
  [29.48862024048175, 60.863485336303704], // sistanandbaluchestan
  [35.711639291719464, 51.40708923339843], // tehran
  [34.644083001967005, 50.87923049926758], // qom
  [35.834689013731015, 50.95051288604736], // alborz
  [38.07414281009269, 46.29630088806152], // eastazerbaijan
  [31.87172661206501, 54.35022354125976], // yazd
  [27.19624340878391, 56.28776550292968], // hormozgan
  [31.302828396061393, 48.68471145629883], // khuzestan
];

export const ROLE = {
  USER: 'User',
  ADMIN: 'Admin',
  MEMBER: 'Member',
}